import * as Zod from 'zod';

export const keyTypesScheme = Zod.object({
  id: Zod.number(),
  label: Zod.string(),
});
